import React from 'react';
import ParentLayout from '../Layout';
import useRouter from '../../../hooks/useRouter';
import Project from '../../projects/Project';
import Resources from '../../projects/_fields/Resources';
import useQuery from './useQuery';
import CardChildrenWrapper from '../../_common_results/CardChildrenWrapper';

export default function Layout(props) {
  const { location } = useRouter();

  const PAGE_SIZE = 10;

  const result = useQuery({
    location,
    PAGE_SIZE
  });

  return (
    <ParentLayout
      breadcrumbs={['Explore', 'Projects']}
      title="Needs Resources"
      description={(
        <span>
          These are projects where an educator indicated they needed additional resources.
          CommunityShare recommends elevating these needs through your networks to help
          draw new partners into the platform.
        </span>
      )}
      pageSize={PAGE_SIZE}
      result={result}
      row={function (project) {
        return (
          <Project key={project.id} project={project}>
            <CardChildrenWrapper>
              <div className="grid grid-cols-2 gap-4 w-full">
                <Resources project={project} />
              </div>
            </CardChildrenWrapper>
          </Project>
        );
      }}
    />
  );
}
